
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import appApplyLeaveInstructions from "@/components/process/AppealProcess/pathwayInstructions/appApplyLeaveInstructions.vue";
import respApplyCrossAppealInstructions from "@/components/process/AppealProcess/pathwayInstructions/respApplyCrossAppealInstructions.vue";

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");


import {GetInstructionFile} from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon,
        appApplyLeaveInstructions,
        respApplyCrossAppealInstructions
    }
})
export default class NeedToApplyLeaveToCrossAppeal extends Vue {    

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void    
    
    showIntroInfo = true;  
    showNoaLeaveInfo = false;    
    showNoaLeaveStayInfo = false;
    
    public showIntro(show: boolean){
        if (show) {
            this.showIntroInfo = true;
            this.$emit('adjustHeights', 0, "19rem");
        } else {
            this.showIntroInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showNoaLeave(show: boolean){
        if (show) {
            this.showNoaLeaveInfo = true;
            this.$emit('adjustHeights', 1, "31.5rem");
        } else {
            this.showNoaLeaveInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showNoaLeaveStay(show: boolean){
        if (show) {
            this.showNoaLeaveStayInfo = true;
            this.$emit('adjustHeights', 2, "30.5rem");
        } else {
            this.showNoaLeaveStayInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" });
    }

    public downloadInstructions(file_name: string){
        GetInstructionFile(file_name);
    }
        

}
